(function() {
  function initSliders() {
    const sliders = document.querySelectorAll('.custom-product-slider-inner:not([data-initialized="true"])');
    
    sliders.forEach(slider => {
      const desktopSlider = slider.dataset.desktopSlider === 'true';
      const mobileSlider = slider.dataset.mobileSlider === 'true';
      const slidesToShowDesktop = parseFloat(slider.dataset.slidesToShowDesktop) || 4;
      const slidesToShowMobile = parseFloat(slider.dataset.slidesToShowMobile) || 2;
      
      if (typeof Swiper !== 'undefined') {
        const swiperInstance = new Swiper(slider, {
          slidesPerView: slidesToShowMobile,
          spaceBetween: 15,
          navigation: {
            nextEl: slider.querySelector('.swiper-button-next'),
            prevEl: slider.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            750: {
              slidesPerView: slidesToShowDesktop,
              enabled: desktopSlider,
              spaceBetween: 20
            }
          },
          enabled: mobileSlider || window.innerWidth >= 750,
          watchOverflow: true,
          loop: false
        });
        slider.setAttribute('data-initialized', 'true');
      }
    });
  }

  function initSwatches() {
    document.querySelectorAll('.custom-product-card:not([data-swatches-initialized="true"])').forEach(card => {
      const mainImg = card.querySelector('.main-image');
      const swatches = card.querySelectorAll('.swatch-item');
      
      swatches.forEach(swatch => {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          const newImgUrl = this.dataset.imageUrl;
          if (newImgUrl && mainImg) {
            mainImg.src = newImgUrl;
            mainImg.srcset = newImgUrl;
            
            swatches.forEach(s => s.classList.remove('active'));
            this.classList.add('active');
            
            const variantUrl = this.dataset.variantUrl;
            if (variantUrl) {
                card.querySelectorAll('a').forEach(a => a.href = variantUrl);
            }
          }
        });
      });
      card.setAttribute('data-swatches-initialized', 'true');
    });
  }

  // Handle dynamic loading patterns (like product-recommendations)
  function setupObservers() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          initSliders();
          initSwatches();
        }
      });
    });

    // Observe specific elements that load content dynamically
    document.querySelectorAll('product-recommendations').forEach(el => {
      observer.observe(el, { childList: true });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initSliders();
    initSwatches();
    setupObservers();
  });

  document.addEventListener('shopify:section:load', () => {
    initSliders();
    initSwatches();
    setupObservers();
  });
})();
